export default __webpack_public_path__ + "static/media/88.4b37bf13.png";